const previousViews = new WeakMap<HTMLElement, string>();
const rowSources = new WeakMap<Element, string>();

/** Preserve keyed file rows, menu state and focus while server data refreshes. */
export function refreshAttachmentView(target: HTMLElement, html: string): void {
  if (previousViews.get(target) === html) return;
  const signature = (row: Element): string => {
    const copy = row.cloneNode(true) as Element;
    for (const element of [copy, ...copy.querySelectorAll("*")]) {
      for (const name of ["open", "data-bound", "data-menu-bound", "data-keyboard-bound"]) element.removeAttribute(name);
    }
    return copy.outerHTML;
  };
  const doc = target.ownerDocument;
  const focused = doc.activeElement as HTMLElement | null;
  const row = focused?.closest<HTMLElement>("[data-attachment-id]");
  const hadFocus = !!focused && target.contains(focused);
  const oldRows = [...target.querySelectorAll<HTMLElement>("[data-attachment-id]")];
  const index = row ? oldRows.indexOf(row) : -1;
  const scroller = target.closest<HTMLElement>(".detail-panel__scroll");
  const scroll = scroller?.scrollTop, offset = hadFocus && row ? row.getBoundingClientRect().top : null;
  const template = doc.createElement("template"); template.innerHTML = html;
  const oldById = new Map(oldRows.map(item => [item.dataset.attachmentId!, item]));
  const openIds = oldRows.filter(item => item.querySelector("details[open]")).map(item => item.dataset.attachmentId);
  for (const next of template.content.querySelectorAll<HTMLElement>("[data-attachment-id]")) {
    const previous = oldById.get(next.dataset.attachmentId!);
    const source = signature(next);
    if (previous && (rowSources.get(previous) || signature(previous)) === source) { rowSources.set(previous, source); next.replaceWith(previous); }
    else { rowSources.set(next, source); if (openIds.includes(next.dataset.attachmentId)) next.querySelector("details")?.setAttribute("open", ""); }
  }
  const data = focused?.getAttributeNames().filter(name => (name.startsWith("data-") && !["data-bound", "data-menu-bound", "data-keyboard-bound"].includes(name)) || name === "href").map(name => [name, focused.getAttribute(name)]);
  target.replaceChildren(template.content);
  previousViews.set(target, html);
  if (hadFocus) {
    const nextRows = [...target.querySelectorAll<HTMLElement>("[data-attachment-id]")];
    const sameRow = nextRows.find(item => item.dataset.attachmentId === row?.dataset.attachmentId);
    let next = focused?.isConnected ? focused : sameRow?.querySelector<HTMLElement>(focused?.tagName === "SUMMARY" ? "summary" : "[data-preview-attachment]");
    if (!focused?.isConnected && sameRow && data?.length) next = [...sameRow.querySelectorAll<HTMLElement>("button,a,summary")].find(item => data.every(([name,value]) => item.getAttribute(name!) === value)) || next;
    if (!next || next.matches(":disabled")) next = (sameRow || nextRows[Math.max(0, Math.min(index, nextRows.length - 1))])?.querySelector<HTMLElement>("button.attachment-file:not(:disabled),a.attachment-file[href],summary");
    if (!next) { target.tabIndex = -1; next = target; }
    next.focus({ preventScroll: true });
    if (scroller && scroll !== undefined) scroller.scrollTop = scroll + (offset !== null && sameRow ? sameRow.getBoundingClientRect().top - offset : 0);
  } else if (scroller && scroll !== undefined) scroller.scrollTop = scroll;
}
